/**
 * IMPORTANT: genTagId has been migrated to @okf/ootils
 *
 * This file now imports from ootils for consistency across the platform.
 * The genTagId function includes Unicode normalization and accent removal
 * to prevent duplicate tags from character variants.
 *
 * @see @okf/ootils/src/utils/genTagId.ts for implementation
 * @see okf-be/routes/api/content/services/_directDataImport/utils/TAG_NORMALIZATION_GUIDE.md
 */
import { genTagId } from '@okf/ootils';

export const checkForDuplicate = (title, category, excludeId, localTagsData) => {
  if (!title?.trim() || !localTagsData?.data) return false;

  const targetTagId = genTagId(title.trim());
  const categoryItems = localTagsData.data.filter(
    (item) => item.meta?.kp_content_type === category && item._id !== excludeId && item?.isEditing !== true
  );

  return categoryItems.some((item) => {
    const existingTagId = genTagId(item.main?.title || "");
    return existingTagId === targetTagId;
  });
};
